// extracted by mini-css-extract-plugin
module.exports = {"imagenBox6":"index-module--imagenBox6--2YGuB","imagenBox11":"index-module--imagenBox11--1RjrH"};